<ion-header>
    <ion-toolbar>
    <ion-title mode="ios" role="heading">{{ prompt }}</ion-title>
    <ion-buttons slot="end">
        <ion-button
            class="icon-button-accessible-background-contrast"
            [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
            (click)="dismiss()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
    </ion-buttons>
</ion-toolbar>
</ion-header>
<ion-content>



        <!-- <h5 class="ion-text-center">{{ prompt }}</h5> -->
        <h2 class="ion-padding ion-text-center">{{ timeDisplay }}</h2>

        <div class="ion-padding ion-text-center">
            <div *ngIf="!errorTooEarly && !errorTooLate">&nbsp;</div>
            <ion-text color="danger" *ngIf="errorTooEarly">Must be after {{ minTimeDisplay }}</ion-text>
            <ion-text color="danger" *ngIf="errorTooLate">Must be before {{ maxTimeDisplay }}</ion-text>
        </div>

        <div class="ion-padding-start">Hour</div>
        <ion-range (ionChange)="formatTimes()" [(ngModel)]="hrs" min="3" max="26">
        </ion-range>
        <div class="range-label-row">
            <div class="ion-float-start">3AM</div>
            <div class="ion-float-end">3AM (next day)</div>
        </div>

        <div class="ion-padding-start">Minute</div>
        <ion-range (ionChange)="formatTimes()" [(ngModel)]="mins" min="0" max="59">
        </ion-range>
        <div class="range-label-row">
            <div class="ion-float-start">:00</div>
            <div class="ion-float-end">:59</div>
        </div>

        <div class="ion-text-center ion-padding">
            <br />
            <ion-button expand="block" class="emphasized-button" [disabled]="errorTooEarly === true || errorTooLate === true" (click)="onSubmit()">Submit</ion-button>
        </div>

        <!-- <div class="ion-padding">
            <h6>Must be after: {{ minTimeDisplay }}</h6>
            <h6>Must be before: {{ maxTimeDisplay }}</h6>
        </div> -->

    <!-- <ion-list>
        <ion-item *ngFor="let time of times" (click)="onClickTime(time)">
            <ion-label>{{ time.display }}</ion-label>
        </ion-item>
    </ion-list>

    <div *ngIf="notEnoughTime">
        <h4 [innerHTML]="'TIME_SELECT_NOT_ENOUGH_TIME' | translate"></h4>
    </div> -->



</ion-content>
